module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"inventories":"Inventuren"},"en":{"inventories":"Inventories"}}')
  delete Component.options._Ctor
}
